import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { fetchClusterList } from '@/slices/resourceSlice';
import Left from './Left';
import Right from './Right';

function HostList({ fetchClusterList }) {
  const [clusterId, setClusterId] = useState();

  useEffect(() => {
    fetchClusterList();
  }, [fetchClusterList]);

  return (
    <Root className='narrow-scrollbar'>
      <Left onSelect={setClusterId} current={clusterId} />
      <Right clusterId={clusterId} />
    </Root>
  );
}

export default connect(null, {
  fetchClusterList,
})(HostList);

const Root = styled.div`
  display: flex;
  overflow-y: auto;
  min-height: calc(100vh - 150px);
`;
